import styled from 'styled-components';
import {dFlexCenter} from '../../../../../globalVariables/GlobalVariables';

export const actionsBar = styled.div`
    ${dFlexCenter}
    padding: 10px;
    gap: 10px;
    background: var(--TA-color-bg-base);
`;
